// Slick slider setting for header shows on mobile
export const mobileMenuSliderSetting = {
	centerMode: false,
	swipeToSlide: true,
	infinite: false,
	mobileFirst: true,
	adaptiveHeight: false,
	slidesToShow: 3.2,
	slidesToScroll: 3,
	variableWidth: false,
	dots: false
};

// Slick slider setting for header shows
export const headerShowSliderSetting = {
	centerMode: false,
	swipeToSlide: true,
	infinite: true,
	mobileFirst: true,
	adaptiveHeight: false,
	slidesToShow: 1,
	slidesToScroll: 1,
	variableWidth: true,
	dots: false
	/*responsive: [
        {
            breakpoint: 940,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 1150,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
            }
        },
    ]*/
};

// Post module slider setting
export const postModuleSliderSetting = {
	centerMode: false,
	swipeToSlide: true,
	infinite: false,
	mobileFirst: true,
	adaptiveHeight: false,
	slidesToShow: 1,
	slidesToScroll: 1,
	variableWidth: false,
	dots: false,
	responsive: [
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2
			}
		},
		{
			breakpoint: 1000,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3
			}
		}
	]
};

// Exclusive module slider setting
export const exclusiveModuleSliderSetting = {
	centerMode: false,
	swipeToSlide: true,
	infinite: false,
	mobileFirst: true,
	adaptiveHeight: false,
	slidesToShow: 1,
	slidesToScroll: 1,
	variableWidth: false,
	dots: false,
	responsive: [
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2
			}
		},
		{
			breakpoint: 1000,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3
			}
		}
	]
};
